import {makeVar} from '@apollo/client'

// Allows us to store the customer's selected unit outside of the cache so it is not over-written by an api call.
// This is an Apollo reactive variable - https://www.apollographql.com/docs/react/local-state/managing-state-with-field-policies/#storing-local-state-in-reactive-variables
export const selectedUnit = makeVar('')
